<template>
    <layout>
        <v-row 
            align="center"
            justify="center"
        > 
            <v-card
                class="pb-6" 
                width="500"
            >
                <v-card-title class="white--text pl-4 primary">
                    REQUIRED DOCUMENTS
                </v-card-title> 

                <v-app-bar
                    flat
                    color="white"
                >
                    <v-toolbar-title class="body-2 pl-0 text-wrap">                        
                        Please upload a scanned copy of the required documents
                        in the appropriate fields below
                    </v-toolbar-title>
                </v-app-bar>

                <v-row 
                    align="center"
                    justify="center"
                    v-for="document in documents"
                    :key="document.label" 
                    class="px-4"                                         
                >
                    <v-col
                        cols="12"                        
                    >
                        <upload-files 
                            v-bind:fileType="document.type"
                            v-bind:fileLabel="document.label"
                            :disabled="document.disabled"
                            :filled="document.filled"
                            :studentRecord="studentRecord"
                            :fileTypeAllowed="document.fileAllowed"
                            :fileAccept="document.fileAccept"
                            @setOverlay="setOverlay"
                        ></upload-files>
                    </v-col>
                </v-row>
            </v-card>
        </v-row>

        <v-overlay
            :value="overlay"
            opacity="0.8"
            z-index="10"                    
        >
            
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>                   
        </v-overlay>
        
    </layout>    
</template>

<script>
import Layout from './layouts/Registration';
import UploadFiles from "./UploadFiles";
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'Documents',

    components: {
        Layout,
        UploadFiles,
        
    }, 

     mounted: function () {
        this.initialize();        
    },
    
    computed: {
        ...mapGetters({
            editRegistration: 'auth/getEditRegistration',
            studentRecord: 'auth/getStudentRecord'
            
        })
    },

    watch: {
        editRegistration: {
            handler () {
                this.setRegistrationStatus();
            }
        }
    },

    data: () => ({        
        documents: [
            {
                label: 'Birth Certificate', 
                placeholder: 'Upload your birth certificate', 
                type: 'birth_certificate',
                ref: 'birth_certificate',
                disabled: true,
                filled: true,
                fileAllowed: 'pdf',
                fileAccept: '.pdf'
            },
            {
                label: 'Immunization Card', 
                placeholder: 'Upload your immunization card', 
                type: 'immunization_card',
                ref: 'immunization_card',
                disabled: true,
                filled: true,
                fileAllowed: 'pdf',
                fileAccept: '.pdf'
            },
            {
                label: 'SEA Slip', 
                placeholder: 'Upload your SEA results slip', 
                type: 'sea_slip',
                ref: 'sea_slip',
                disabled: true,
                filled: true,
                fileAllowed: 'pdf',
                fileAccept: '.pdf'
            },
            {
                label: 'Passport Photo', 
                placeholder: 'Upload Passport Photo', 
                type: 'picture',
                ref: 'picture',
                disabled: true,
                filled: true,
                fileAllowed: 'jpeg/png/jpg',
                fileAccept: 'image/*'
            },
        ], 
        overlay: false,     
        
    }),

    methods: {
         ...mapActions({
            getStudentData: 'auth/getStudent', 
        }),

        async initialize () {
            //await this.getStudentData();
            this.setRegistrationStatus();
        },
        setRegistrationStatus () {
            this.documents.forEach((field) => {
                field.disabled = !this.editRegistration;
                field.filled = !this.editRegistration;
            } )
        },
        
        setOverlay(value) {
            this.overlay = value;
        },  
    }
    
}
</script>